/// <reference path="../../../../typings/index.d.ts" />
angular.module('app').factory('UsersAdminServiceApi', ($http, ApiErrorService) => {
    return {
        passwordRules: passwordRules,
        users: users,
        uploadUsers: uploadUsers,
        singleUser: singleUser,
        getTestersList: getTestersList,
        saveUser: saveUser,
        resetPassword: resetPassword,
        deleteUser: deleteUser,
        hardDeleteUser: hardDeleteUser,
        enableLockoutForUser: enableLockoutForUser,
        lockUser: lockUser
    };
    function passwordRules() {
        return $http.get(`api/UsersAdmin/PasswordRules`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function users() {
        return $http.get(`api/UsersAdmin/Users`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function uploadUsers(filter) {
        return $http.get(`api/UsersAdmin/UploadUsers?filter=${filter}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function singleUser(userId) {
        return $http.get(`api/UsersAdmin/SingleUser?userId=${userId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getTestersList() {
        return $http.get(`api/UsersAdmin/GetTestersList`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function saveUser(userModel) {
        return $http.post(`api/UsersAdmin/SaveUser`, userModel)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function resetPassword(model) {
        return $http.post(`api/UsersAdmin/ResetPassword`, model)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function deleteUser(id, isDeleted) {
        return $http.post(`api/UsersAdmin/DeleteUser?id=${id}&isDeleted=${isDeleted}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function hardDeleteUser(userId) {
        return $http.post(`api/UsersAdmin/HardDeleteUser?userId=${userId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function enableLockoutForUser(id, isLocked) {
        return $http.post(`api/UsersAdmin/EnableLockoutForUser?id=${id}&isLocked=${isLocked}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function lockUser(req) {
        return $http.post(`api/UsersAdmin/LockUser`, req)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
});
